import React from 'react'
import { Check } from 'react-feather'
import './CampaignStepper.scss'

const PRIMARY = '#185FA5'

export function CampaignStepper({
  steps,
  activeIndex,
  onStepClick,
  canNavigateToStep
}) {
  return (
    <nav className="campaign-stepper" aria-label="Etapas do envio">
      <ol className="campaign-stepper__list">
        {steps.map((label, index) => {
          const isActive = index === activeIndex
          const isComplete = index < activeIndex
          const isFuture = index > activeIndex

          const canClick =
            onStepClick &&
            index !== activeIndex &&
            (index < activeIndex ||
              (typeof canNavigateToStep === 'function'
                ? canNavigateToStep(index)
                : false))

          return (
            <li
              key={label}
              className={`campaign-stepper__item ${
                isActive ? 'is-active' : ''
              } ${isComplete ? 'is-complete' : ''} ${isFuture ? 'is-future' : ''}`}
            >
              <button
                type="button"
                className="campaign-stepper__step-btn"
                disabled={!canClick}
                onClick={() => canClick && onStepClick(index)}
                aria-current={isActive ? 'step' : undefined}
                aria-label={
                  canClick
                    ? `Ir para etapa: ${label}`
                    : isActive
                    ? `Etapa atual: ${label}`
                    : label
                }
              >
                <span
                  className="campaign-stepper__circle"
                  style={
                    isActive
                      ? {
                          background: PRIMARY,
                          color: '#fff',
                          borderColor: PRIMARY
                        }
                      : undefined
                  }
                >
                  {isComplete ? (
                    <Check size={14} strokeWidth={3} aria-hidden />
                  ) : (
                    <span className="campaign-stepper__num">{index + 1}</span>
                  )}
                </span>
                <span className="campaign-stepper__label">{label}</span>
              </button>
              {index < steps.length - 1 ? (
                <span
                  className="campaign-stepper__connector"
                  aria-hidden
                  style={{
                    background:
                      index < activeIndex ? PRIMARY : 'rgba(0,0,0,0.08)'
                  }}
                />
              ) : null}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
